var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectionBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 30C15.3062 30 16.4175 29.1652 16.8293 28H25.5C27.9853 28 30 25.9853 30 23.5C30 21.0147 27.9853 19 25.5 19H14.5C13.1193 19 12 17.8807 12 16.5C12 15.1193 13.1193 14 14.5 14H17.5858L16.2929 15.2929L17.7071 16.7071L21.4142 13L17.7071 9.29291L16.2929 10.7071L17.5858 12H14.5C12.0147 12 10 14.0147 10 16.5C10 18.9853 12.0147 21 14.5 21H25.5C26.8807 21 28 22.1193 28 23.5C28 24.8807 26.8807 26 25.5 26H16.8293C16.4175 24.8348 15.3062 24 14 24C12.3431 24 11 25.3432 11 27C11 28.6569 12.3431 30 14 30ZM13 27C13 26.4477 13.4477 26 14 26C14.5523 26 15 26.4477 15 27C15 27.5523 14.5523 28 14 28C13.4477 28 13 27.5523 13 27ZM26 10C27.6569 10 29 11.3432 29 13C29 14.6569 27.6569 16 26 16C24.3431 16 23 14.6569 23 13C23 11.3432 24.3431 10 26 10ZM25 13C25 12.4477 25.4477 12 26 12C26.5523 12 27 12.4477 27 13C27 13.5523 26.5523 14 26 14C25.4477 14 25 13.5523 25 13Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionBlack);
export default __webpack_public_path__ + "static/media/connection-black.38f8c407.svg";
export { ForwardRef as ReactComponent };